import ProductTemplate from "../../Biscuits-Template/Template";
import BisImg from "../../../assets/products/crispy bites/Choco-Chip-Cookies.png";
import BiscuitImg from "../../../assets/products/crispy bites/delicious-chocolate-chip-cookie-treat.png";
import { Helmet } from "react-helmet-async";

const BiscuitData = [
  {
    grams: 75,
  },
];

export default function ChocoChipProduct() {
  return (
    <>
      <Helmet>
        <title>
          Choco Chip Cookies – BearBitz | Premium Biscuits & Cookies
        </title>
        <meta
          name="description"
          content="Explore BearBitz Crispy Choco Chip Cookies — rich choco flavor with a satisfying crunch."
        />
        <meta
          name="keywords"
          content="Crispy Choco Chip Cookies, BearBitz Choco Chip Cookies"
        />
        <link
          rel="canonical"
          href="https://www.bearbitz.in/crispy-biscuit/choco-chip-cookies"
        />
        <meta
          property="og:title"
          content="Crispy Choco Chip Cookies – BearBitz"
        />
        <meta
          property="og:description"
          content="Buttery, crisp biscuits by BearBitz designed for premium quality and export standards."
        />
      </Helmet>

      <ProductTemplate
        productTitle="CHOCO CHIP COOKIES"
        productImage={BisImg}
        description="The irresistible taste of Choco Chip Cookies, loaded with rich chocolate chips and baked to a perfect crunch. Each bite delivers a delightful blend of sweetness and chocolatey goodness, making them a favorite treat for kids, teens, and cookie lovers of all ages."
        tableData={BiscuitData}
        BiscuitLogo={BiscuitImg}
        textColor="#68171A"
        sectionBgColor="#FFDDA4"
        productBgcolor="#FFECCB"
        tableheadBgcolor="#68171A"
        tableBgcolor="#FFF2DC"
        footerBgcolor="#68171A"
      />
    </>
  );
}
